import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { ConfirmDisclosureRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { ConfirmDisclosureResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const confirmDisclosure = (request: ConfirmDisclosureRequest, options?: CashRequestOptions) =>
  post<ConfirmDisclosureRequest, ConfirmDisclosureResponse>('/2.0/cash/confirm-disclosure', request, {
    ...options,
    rejectOnError: true,
  })
